import React, { useEffect, useState } from 'react';
import { Size } from './size';
import { Enclosure } from './enclosure';
import { showDistanceFromYou } from '../../helpers/spot';
import SvgPin from 'src/assets/svg/SvgPin.svg';
import './index.scss';

const ListingHead = ({ address, title, fncd, size, sizeUnits, city, state, distanceFrom, userDetails, publicPark }) => {
    const [distanceText, setDistanceText] = useState('');

    useEffect(() => {
        setDistanceText(showDistanceFromYou(distanceFrom, userDetails));
    }, []);

    return (
        <section id="overview">
            <div className="row head-row-title">
                <div className="col-md-12">
                    <h1 className="head-title snif-m1 snif-xl-pc">{title}</h1>
                </div>
            </div>
            {publicPark && <p className="public-tag snif-xs snif-bold text-light mt-1">PUBLIC DOG PARK</p>}
            <div className="head-location">
                <SvgPin />
                <div>
                    {address && <span>{address} </span>}
                    {city ? <span>{city}</span> : null}
                    {state ? <span>, {state}</span> : null}
                    {distanceText}
                </div>
            </div>
            <div className="row head-info">
                <div className="col-md-12">
                    <Enclosure fncd={fncd} />
                    <Size size={size} sizeUnits={sizeUnits} />
                </div>
            </div>
        </section>
    );
};

export default ListingHead;
